import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, Facebook, Instagram } from "lucide-react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* entreprise info */}
          <div className="footer-section">
            <div className="footer-logo">
              <div className="logo-icon">
                <img
                  src="/images/logo.png"
                  alt="Logo"
                  style={{ width: "40px", height: "40px" }}
                />
              </div>
              <span>Lomatout Faire</span>
            </div>
            <p className="footer-description">
              Votre partenaire idéal pour la rénovation de votre habitation.
              Nous transformons vos rêves en réalité.
            </p>
          </div>

          {/* lien de nav */}
          <div className="footer-section">
            <h3>Navigation</h3>
            <ul className="footer-links">
              <li>
                <Link to="/">Accueil</Link>
              </li>
              <li>
                <Link to="/portfolio">Portfolio</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-section">
            <h3>Contact</h3>
            <ul className="contact-info">
              <li>
                <Phone size={18} />
                <a href="tel:+32494311201">+32 (0)494 31 12 01</a>
              </li>
              <li>
                <Mail size={18} />
                <a href="mailto:info@lomatoutfaire.be">info@lomatoutfaire.be</a>
              </li>
            </ul>
          </div>

          {/* reseau sociaux */}
          <div className="footer-section">
            <h3>Suivez-nous</h3>
            <div className="social-links">
              <a
                href="https://www.facebook.com/profile.php?id=100083274981676"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <Facebook size={24} />
              </a>
              <a
                href="https://www.instagram.com/lomatout_faire"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <Instagram size={24} />
              </a>
            </div>
          </div>
        </div>

        {/* droit */}
        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} Lomatout Faire. Tous droits
            réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
